import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import Axios from './request/https'
import store from './store'
import api from './request/api'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import vuetify from '@/plugins/vuetify' // path to vuetify export

Vue.use(ElementUI, { locale })
window.$ = window.jQuery = require('jquery');
// Vue.prototype.$http = Axios;
Vue.prototype.$api = api;

// const token = localStorage.getItem('token')
// if (token) {
//   Vue.prototype.$http.defaults.headers.common['Authorization'] = token
// }

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
